module.exports = __webpack_public_path__ + "img/secondHand1_en.10e35064.png";